import React from 'react';
import game from '../../images/game.PNG'
import game2 from "../../images/game-2.PNG"
import { red2, red3, red5, tech, tech2, tech3, cook1, cook2, cook3, dictionary, dictionary2, dictionary3, jamuna1, jamuna2, jamuna3, book, book2, book3, crypto1, crypto2, crypto3, chat, chat2,real,real2, real3 } from '../index'
import { Carousel } from 'react-bootstrap';
const ReactProject = () => {
    return (
        <div class="container">
            {/* RealXstate projects */}
            <div className="row justify-content-center mt-4">
                <div className="col-md-4">
                    <Carousel fade className='mt-3'>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={real}
                                alt="Crypto update today"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={real2}
                                alt="Crypto update today"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={real3}
                                alt="Crypto update today"
                            />
                        </Carousel.Item>
                    </Carousel>
                </div>
                <div className="col-md-5">
                    <div className="mt-3">
                        <h4 className="textColor">RealXstate</h4>
                        <p className="textColor2">A beautiful Real Estate Next js Application: search property by your choice: filtering option; to buy or rent .</p>
                        <div className="mt-1 technology mb-2">
                            <span className="customButton text-white">Next js </span>
                            <span className="customButton text-white">Chakra UI</span>
                            <span className="customButton text-white">Rapid Api</span>
                        </div>
                        <a href="https://github.com/rajonahmed749/real-state-website" target="_blank" rel="noreferrer"> <i className="fab fa-github workLink mx-2"></i></a>
                        <a href="https://real-state-website-pi.vercel.app/" target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt workLink mx-1"></i></a>
                    </div>
                </div>
            </div>
            {/* Crypto projects */}
            <div className="row justify-content-center mt-4">
                <div className="col-md-4">
                    <Carousel fade className='mt-3'>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={crypto1}
                                alt="Crypto update today"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={crypto2}
                                alt="Crypto update today"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={crypto3}
                                alt="Crypto update today"
                            />
                        </Carousel.Item>
                    </Carousel>
                </div>
                <div className="col-md-5">
                    <div className="mt-3">
                        <h4 className="textColor">Crypto Update Today</h4>
                        <p className="textColor2">A React.js based web application where daily cryptocurrency updates are shown statistically. By using Rapid API a list of cryptocurrencies & exchange points is also shown.</p>
                        <div className="mt-1 technology mb-2">
                            <span className="customButton text-white">React js </span>
                            <span className="customButton text-white">Ant Design</span>
                            <span className="customButton text-white">Rapid Api</span>
                            <span className="customButton text-white">Firebase</span>
                        </div>
                        <a href="https://github.com/rajonahmed749/crypto-application" target="_blank" rel="noreferrer"> <i className="fab fa-github workLink mx-2"></i></a>
                        <a href="https://crypto-update-today.web.app/" target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt workLink mx-1"></i></a>
                    </div>
                </div>
            </div>
            {/* Dictionary project */}
            <div className="row justify-content-center mt-4">
                <div className="col-md-4">
                    <Carousel className='mt-3'>
                        <Carousel.Item interval={1000}>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={dictionary}
                                alt="First slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={dictionary2}
                                alt="Second slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={dictionary3}
                                alt="Third slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                </div>
                <div className="col-md-5">
                    <div className="mt-3">
                        <h4 className="textColor">Word Warrior Dictionary</h4>
                        <p className="textColor2">A progressive web application based on MERN technologies. Through this dictionary you can search words as well as by google log in system, you can add & see your added word list.</p>
                        <div className="mt-1 technology mb-2">
                            <span className="customButton text-white">React js </span>
                            <span className="customButton text-white">Material UI </span>
                            <span className="customButton text-white">Node js</span>
                            <span className="customButton text-white">MongoDB</span>
                            <span className="customButton text-white">Express js</span>
                            <span className="customButton text-white">Firebase</span>
                        </div>
                        <a href="https://github.com/rajonahmed749/dictionary" target="_blank" rel="noreferrer"> <i className="fab fa-github workLink mx-2"></i></a>
                        <a href="https://word-warrior.web.app/" target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt workLink mx-1"></i></a>
                    </div>
                </div>
            </div>
            {/* Jamuna Project */}
            <div className="row justify-content-center mt-4">
                <div className="col-md-4">
                    <Carousel fade className='mt-3'>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={jamuna1}
                                alt="First slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={jamuna2}
                                alt="Second slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={jamuna3}
                                alt="Third slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                </div>
                <div className="col-md-5">
                    <div className="mt-3">
                        <h4 className="textColor">Jamuna Daigonistic center</h4>
                        <p className="textColor2">A full-stack responsive Doctor's appointment booking web app. That's also a multipage app where you can pick the date and time and fix an appointment with a doctor.</p>
                        <div className="mt-1 technology mb-2">
                            <span className="customButton text-white">React js </span>
                            <span className="customButton text-white">Node js</span>
                            <span className="customButton text-white">MongoDB</span>
                            <span className="customButton text-white">Express js</span>
                            <span className="customButton text-white">Firebase</span>
                        </div>
                        <a href="https://github.com/rajonahmed749/jamuna-diagonistic-center" target="_blank" rel="noreferrer"> <i className="fab fa-github workLink mx-2"></i></a>
                        <a href="https://jamuna-diagonistic-center.web.app/" target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt workLink mx-1"></i></a>
                    </div>
                </div>
            </div>
            {/* Chat Application */}
            <div className="row justify-content-center mt-4">
                <div className="col-md-4">
                    <Carousel className='mt-3'>
                        <Carousel.Item interval={1000}>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={chat}
                                alt="First slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={chat2}
                                alt="Second slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                </div>
                <div className="col-md-5">
                    <div className="mt-3">
                        <h4 className="textColor">Adda Today chat application</h4>
                        <p className="textColor2">A chat application based on React-chat-engine. By signing with google/facebook anyone can send a message to his/her closest person :)</p>
                        <div className="mt-1 technology mb-2">
                            <span className="customButton text-white">React js </span>
                            <span className="customButton text-white">React Chat engine</span>
                            <span className="customButton text-white">Firebase hosting</span>
                        </div>
                        <a href="https://github.com/rajonahmed749/adda-chat-application" target="_blank" rel="noreferrer"><i className="fab fa-github workLink mx-2"></i></a>
                        <a href="https://adda-today.web.app/" target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt workLink mx-1"></i></a>
                    </div>
                </div>
            </div>
            {/* Red mountain projects */}
            <div className="row justify-content-center mt-4">
                <div className="col-md-4">
                    <Carousel className='mt-3'>
                        <Carousel.Item interval={1000}>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={red3}
                                alt="First slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={red2}
                                alt="Second slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={red5}
                                alt="Third slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                </div>
                <div className="col-md-5">
                    <div className="mt-3">
                        <h4 className="textColor">Red Mountain Kids</h4>
                        <p className="textColor2">It's a kindergarten school website where a parent can admit their child. The user can also see the programs that are offered by the authority.</p>
                        <div className="mt-1 technology mb-2">
                            <span className="customButton text-white">React js </span>
                            <span className="customButton text-white">Node js</span>
                            <span className="customButton text-white">MongoDB</span>
                            <span className="customButton text-white">Express js</span>
                        </div>
                        <a href="https://github.com/rajonahmed749/red-mountain" target="_blank" rel="noreferrer"> <i className="fab fa-github workLink mx-2"></i></a>
                        <a href="https://red-mountain-kids.web.app/" target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt workLink mx-1"></i></a>
                    </div>
                </div>
            </div>
            {/* The Book Store */}
            <div className="row justify-content-center mt-4">
                <div className="col-md-4">
                    <Carousel fade className='mt-3'>
                        <Carousel.Item >
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={book}
                                alt="First slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={book2}
                                alt="Second slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={book3}
                                alt="Third slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                </div>
                <div className="col-md-5">
                    <div className="mt-3">
                        <h4 className="textColor">The Book Store</h4>
                        <p className="textColor2">React-based single-page book store site where a user can pick a book and order that book. Firebase authentication system is used for user login. React-router also used for the protected page.</p>
                        <div className="mt-1 technology mb-2">
                            <span className="customButton text-white">React js </span>
                            <span className="customButton text-white">React router dom </span>
                            <span className="customButton text-white">Node js</span>
                            <span className="customButton text-white">MongoDB</span>
                            <span className="customButton text-white">Express js</span>
                        </div>
                        <a href="https://github.com/rajonahmed749/book-store" target="_blank" rel="noreferrer"> <i className="fab fa-github workLink mx-2"></i></a>
                        <a href="https://the-book-store-b0c0b.web.app/" target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt workLink mx-1"></i></a>
                    </div>
                </div>
            </div>
            {/* Tech space site */}
            <div className="row justify-content-center mt-4">
                <div className="col-md-4">
                    <Carousel className='mt-3'>
                        <Carousel.Item interval={1000}>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={tech}
                                alt="First slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={tech2}
                                alt="Second slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={tech3}
                                alt="Third slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                </div>
                <div className="col-md-5">
                    <div className="mt-3">
                        <h4 className="textColor">Techspace Site</h4>
                        <p className="textColor2">React-based single-page tech space site. Ant design is used for Ui styling & Netlify used for hosting.</p>
                        <div className="mt-1 technology mb-2">
                            <span className="customButton text-white">React js </span>
                            <span className="customButton text-white">Ant Design</span>
                            <span className="customButton text-white">Netlify</span>
                        </div>
                        <a href="https://github.com/rajonahmed749/tech-space" target="_blank" rel="noreferrer"> <i className="fab fa-github workLink mx-2"></i></a>
                        <a href="https://tech-spaces.netlify.app/" target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt workLink mx-1"></i></a>
                    </div>
                </div>
            </div>
            {/* The Cooking master */}
            <div className="row justify-content-center mt-4">
                <div className="col-md-4">
                    <Carousel fade className='mt-3'>
                        <Carousel.Item >
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={cook1}
                                alt="First slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={cook2}
                                alt="Second slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={cook3}
                                alt="Third slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                </div>
                <div className="col-md-5">
                    <div className="mt-3">
                        <h4 className="textColor">The Cooking master</h4>
                        <p className="textColor2">A food hub restaurant made with Javascript,Bootstrap, html5, css3.</p>
                        <div className="mt-1 technology mb-2">
                            <span className="customButton text-white">Javascript </span>
                            <span className="customButton text-white">Bootstrap</span>
                            <span className="customButton text-white">Css</span>
                            <span className="customButton text-white">HTML5</span>
                        </div>
                        <a href="https://github.com/rajonahmed749/cooking-master" target="_blank" rel="noreferrer"> <i className="fab fa-github workLink mx-2"></i></a>
                        <a href="https://rajonahmed749.github.io/cooking-master/index.html" target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt workLink mx-1"></i></a>
                    </div>
                </div>
            </div>
            {/* Tic Toc toe Game */}
            <div className="row justify-content-center mt-4">
                <div className="col-md-4">
                    <Carousel fade className='mt-3'>
                        <Carousel.Item >
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={game}
                                alt="tic tac toe game"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100 workSlider rounded"
                                src={game2}
                                alt="Second slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                </div>
                <div className="col-md-5">
                    <div className="mt-3">
                        <h4 className="textColor">Beautiful Tic Toc toe game</h4>
                        <p className="textColor2">This is simple but beautiful Tic tac toe game ever on web. Play and enjoy the game .</p>
                        <div className="mt-1 technology mb-2">
                            <span className="customButton text-white">React js</span>
                            <span className="customButton text-white">Javascript</span>
                            <span className="customButton text-white">ES6</span>
                            <span className="customButton text-white">CSS3</span>
                            <span className="customButton text-white">HTML5</span>
                        </div>
                        <a href="https://github.com/rajonahmed749/react-tic-tac-toe-game" target="_blank" rel="noreferrer"> <i className="fab fa-github workLink mx-2"></i></a>
                        <a href="https://tic-tac-games.netlify.app/" target="_blank" rel="noreferrer"><i className="fas fa-external-link-alt workLink mx-1"></i></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReactProject;